<section class="container-fluid">
    <div class="row py-2"></div>
    <div class="row d-flex align-items-end">
        <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-floating">
                <select class="form-select" [(ngModel)]="wagsMonth" (change)="wagsMonthBasedDetailsGet(wagsMonth)">
                    <option selected disabled value="">Select a Wags Month</option>
                    <option *ngFor="let month of getAllWagsMonth">{{month}}</option>
                </select>
                <label for="dateInput">List Of Wags Month</label>
            </div>
        </div>

        <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-floating">
                <select class="form-select" [(ngModel)]="selectedEmployeeName" (change)="filterByEmployee()">
                    <option value="">All Employees</option>
                    <option *ngFor="let name of employeeNames" [value]="name">{{ name }}</option>
                </select>
                <label for="employeeSelect">Employee Name</label>
            </div>
        </div>


        <div class="col-md-4 col-lg-3 col-12 mb-2"></div>
        <!-- Buttons in the same row -->
        <div class="col-md-4 col-lg-3 col-12 mb-2 d-flex justify-content-end gap-2">
            <!-- <button type="button" class="btn btn-success" (click)="downloadExcel()">Download Excel</button>
      <button type="button" class="btn btn-danger" (click)="downloadPDF()">Download Pdf</button> -->
        </div>
    </div>



    <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
        <table class="table table-bordered table-rounded text-center">
            <thead class="table-primary">
                <tr>
                    <th>S.No</th>
                    <th>Employee Name</th>
                    <th>Total Given Images</th>
                    <th>Completed Images</th>
                    <th>Total Indexing/Images</th>
                    <th>No Extractable & Administrative Images</th>
                    <th>Accountable Indexing/Images</th>
                    <th>Accountable Cost</th>
                    <th>Pending Images</th>
                    <th>Worksheet View</th>
                </tr>
            </thead>
            <tbody *ngIf="aggregatedData.length > 0; else noDataFound">
                <tr *ngFor="let entry of aggregatedData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ entry?.employeeName || "-"}}</td>
                    <td>{{ entry?.totalImageCount || "-"}}</td>
                    <td>{{ entry?.noOfImagesCompleted || "-"}}</td>
                    <td>{{ entry?.noOfLinesTyped || "-"}}</td>
                    <td>{{ entry?.noExtractableData || "-"}}</td>
                    <td>{{ entry?.accountableIndexing || "-"}}</td>
                    <td>{{ entry?.accountIndexingCost || "-"}}</td>
                    <td>{{ entry?.availableCount || "-"}}</td>
                    <td>
                        <span class="fa far fa-eye text-primary" style="cursor:pointer;"
                            (click)="openModal(entry)"></span>
                    </td>
                </tr>
            </tbody>
            <ng-template #noDataFound>
                <tr>
                    <td colspan="13" class="text-center text-danger fw-bolder">Data Not Found</td>
                </tr>
            </ng-template>
        </table>
    </div>

    <!-- Modal -->
    <div *ngIf="isShowPopup">
        <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header d-flex flex-column align-items-start">
                        <div class="d-flex w-100 justify-content-between align-items-center">
                            <h5 class="modal-title mb-0">
                                {{ selectedEmployee?.employeeName }} - Worksheet Details
                            </h5>
                            <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
                        </div>
                    </div>

                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="completedImages" placeholder="Total Completed Images"
                                        [value]="totalCompletedImageCount || 0">
                                    <label for="completedImages" class="text-sm">Total Completed Images</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="totalIndexCount" placeholder="Total Index Count"
                                        [value]="TotalIndexCount || 0">
                                    <label for="totalIndexCount" class="text-sm">Total Index/Image Count</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="noExtractableDataCount" placeholder="No Extractable Data"
                                        [value]="noExtractableDataCount || 0">
                                    <label for="noExtractableDataCount" class="text-sm">No Extractable Data</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="accountableIndexingCount" placeholder="Accountable Indexing Count"
                                        [value]="accountableIndexingCount || 0">
                                    <label for="accountableIndexingCount" class="text-sm">Accountable Indexing/Image
                                        Count</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="anyAddedImageCount" placeholder="Total Added Images"
                                        [value]="anyAddedImageCount || 0">
                                    <label for="anyAddedImageCount" class="text-sm">Total Added Images</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm" id="assignCount"
                                        placeholder="Total Reassigned" [value]="assignCount || 0">
                                    <label for="assignCount" class="text-sm">Total Reassigned</label>
                                </div>
                            </div>

                            <div class="col-auto">
                                <div class="form-floating">
                                    <input type="text" readonly class="form-control form-control-sm"
                                        id="accountableCost" placeholder="Accountable Cost"
                                        [value]="(accountIndexingCost.toString() | currency:'INR') || 0">
                                    <label for="accountableCost" class="text-sm">Accountable Cost</label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-2 table-wrapper-scroll-y tableFixHead">
                            <table class="table table-bordered table-rounded text-center">
                                <thead class="table-primary text-sm">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Entry Date</th>
                                        <th>Batch Number</th>
                                        <th>Page Starting No</th>
                                        <th>Page Ending No</th>
                                        <th>Total Given Images</th>
                                        <th>Added Images</th>
                                        <th>Completed Images</th>
                                        <th>Pending Images</th>
                                        <th>Total Indexing/Images</th>
                                        <th>No Extractable & Administrative Images</th>
                                        <th>Accountable Indexing/Images</th>
                                        <th>Leave Status</th>
                                        <th>Reassigned Status</th>
                                        <th>Reassigned Count</th>
                                    </tr>
                                </thead>
                                <tbody class="text-sm">
                                    <tr *ngFor="let entry of selectedEmployee?.entries;let i = index">
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ entry.entryDate | date: 'dd-MMM-yyyy' }}</td>
                                        <td>{{ entry?.batchNumber || '-' }}</td>
                                        <td>{{ entry?.pageStartingNumber || '-' }}</td>
                                        <td>{{ entry?.pageEndingNumber || '-' }}</td>
                                        <td>{{ entry?.totalImageCount || '-' }}</td>
                                        <td>{{ entry?.anyAddedImageCount || '-' }}</td>
                                        <td>{{ entry?.noOfImagesCompleted || '-' }}</td>
                                        <td>{{ entry?.availableCount || '-' }}</td>
                                        <td>{{ entry?.noOfLinesTyped || '-' }}</td>
                                        <td>{{ entry?.noExtractableData || '-' }}</td>
                                        <td>{{ entry?.accountableIndexing || '-' }}</td>
                                        <td>{{ entry?.accountIndexingCost || '-'}}</td>
                                        <td>{{ entry?.isLeave === true ? 'Yes' : entry?.isLeave === false ? 'No' : '-'
                                            }}</td>
                                        <td>{{ entry?.isAssigned === true ? 'Yes' : entry?.isAssigned === false ? 'No' :
                                            '-' }}</td>
                                        <td>{{entry?.assignCount || "-" }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>